import { Token } from "@euglena/compact";

export const isTokenValid = (token: Token | undefined) => {
    return token && token.decryptedToken.expireAt > new Date().getTime();
}